import { BrowserLogger } from './browser-logger';

const logger = new BrowserLogger();
export { logger};

